import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, useTheme } from "@mui/material";

interface MyTimesheetCalendarTooltipStateProps {
  state: "requested" | "approved" | "recorded" | "rejected" | "cancelled";
}

export const MyTimesheetCalendarTooltipState = ({
  state,
}: MyTimesheetCalendarTooltipStateProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  let color = "";
  switch (state) {
    case "requested":
      color = theme.palette.yellowBase.main;
      break;
    case "approved":
      color = theme.palette.greenBase.main;
      break;
    case "recorded":
      color = theme.palette.greenBase.main;
      break;
    case "rejected":
      color = theme.palette.primary.main;
      break;
    case "cancelled":
      color = theme.palette.primary.main;
      break;
    default:
      color = "";
  }

  return (
    <Box
      style={{
        border: `1px solid ${color}`,
        borderRadius: 12,
        padding: "2px 6px",
      }}
    >
      <Typography variant="caption" color="white.main">
        {t(`MY_LEAVE_${state.toUpperCase()}`)}
      </Typography>
    </Box>
  );
};

export default MyTimesheetCalendarTooltipState;
